<header class="page" *ngIf="showHeader()" [class.no-logo]="!logo" [class.has-image]="image">
	<div class="row" *ngIf="logo">
		<div class="columns small-12" [class.text-center]="logoCentered">
			<img [src]="logo" [alt]="projectName" class="logo">
		</div>
	</div>

	<div class="row collapse" *ngIf="image">
		<div class="small-12 columns">
			<img [src]="image" alt="" class="image">
		</div>
	</div>

	<div class="row">
		<div class="columns small-12">
			<!-- headline -->
			<h1 *ngIf="hasHeadline()">{{ "headline.default" | translate }}</h1>

			<!-- Progess bar -->
			<project-progress *ngIf="step != 'end'" [size]="size"></project-progress>

			<!-- Teaser -->
			<p class="teaser" *ngIf="size != 'small' && teaser" [innerHTML]="teaser | nl2br"></p>

			<!-- subheadline -->
			<h2 *ngIf="size == 'small' && subheadline">{{ subheadline }}</h2>

		</div>
	</div>
</header>
